__turbopack_context__.v({
  "closedDay": "OutletOpeningHoursSet-module-scss-module__2m7X9G__closedDay",
  "container": "OutletOpeningHoursSet-module-scss-module__2m7X9G__container",
  "day": "OutletOpeningHoursSet-module-scss-module__2m7X9G__day",
  "exceptionDay": "OutletOpeningHoursSet-module-scss-module__2m7X9G__exceptionDay",
  "isToday": "OutletOpeningHoursSet-module-scss-module__2m7X9G__isToday",
  "openingDayCell": "OutletOpeningHoursSet-module-scss-module__2m7X9G__openingDayCell",
  "openingHoursRow": "OutletOpeningHoursSet-module-scss-module__2m7X9G__openingHoursRow",
  "openingPeriodCell": "OutletOpeningHoursSet-module-scss-module__2m7X9G__openingPeriodCell",
});
